let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import { match } from 'ts-pattern';
import styled, { css } from 'styled-components';
import { fonts, colors } from '@ovpn-ui/styles';
import loader from '../loader';
import TextBox from '../TextBox';
import { shadows, fontStack } from '../styles';
const variantMixin = ({
  variant
}) => match(variant).with('primary', () => css(_t || (_t = _`
                color: ${0};

                background-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.neutralWhite, colors.primaryBase, colors.primaryBaseHover, colors.primaryBase, colors.primaryBaseActive)).with('secondary', () => css(_t2 || (_t2 = _`
                color: ${0};

                background-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.neutralTextTitle, colors.secondaryBase, colors.secondaryBaseHover, colors.secondaryBase, colors.secondaryBaseActive)).with('tertiary', () => css(_t3 || (_t3 = _`
                color: ${0};

                background-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.neutralTextBody, colors.neutralWhite, colors.neutralBgHover, colors.neutralWhite, colors.neutralBg)).with('ghost', () => css(_t4 || (_t4 = _`
                color: ${0};

                background-color: ${0};

                border-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.neutralTextBody, colors.neutralWhite, colors.neutralBorder, colors.neutralBgHover, colors.neutralWhite, colors.neutralLight)).with('ghostBlue', () => css(_t5 || (_t5 = _`
                color: ${0};

                background-color: ${0};

                border-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.primaryBase, colors.neutralWhite, colors.primaryBase, colors.neutralBgHover, colors.neutralWhite, colors.neutralLight)).with('success', () => css(_t6 || (_t6 = _`
                color: ${0};

                background-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.neutralWhite, colors.successBase, colors.successBaseHover, colors.successBase, colors.successBaseActive)).with('warning', () => css(_t7 || (_t7 = _`
                color: ${0};

                background-color: ${0};

                &:hover:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:focus:not([aria-disabled]) {
                    background-color: ${0};
                }

                &:active:not([aria-disabled]) {
                    background-color: ${0};
                }
            `), colors.neutralWhite, colors.warningBase, colors.warningBaseHover, colors.warningBase, colors.warningBaseActive)).exhaustive();
const spinnerMixin = ({
  size,
  variant
}) => css(_t8 || (_t8 = _`
    width: ${0};
    height: ${0};

    ${0}
`), match(size).with('sm', () => '20px').with('md', () => '24px').exhaustive(), match(size).with('sm', () => '20px').with('md', () => '24px').exhaustive(), loader(match(variant).with('primary', 'success', 'warning', () => colors.neutralWhite).with('secondary', () => colors.neutralTextTitle).with('tertiary', 'ghost', () => colors.neutralTextBody).with('ghostBlue', () => colors.primaryBase).exhaustive(), size === 'sm' ? '16px' : '20px'));
export const Spinner = styled.div(_t9 || (_t9 = _`
    position: relative;

    ${0};
`), spinnerMixin);
export const Button = styled(TextBox)(_t10 || (_t10 = _`
    position: relative;

    display: inline-flex;
    gap: 8px;
    align-items: center;
    justify-content: center;

    min-width: min-content;
    min-height: ${0};

    padding: 6px 14px;

    font-family: ${0};
    white-space: ${0};
    text-align: center;
    text-transform: capitalize;
    text-decoration: none;
    vertical-align: middle;

    ${0}

    border: 1px solid transparent;
    border-radius: 4px;
    outline: none;

    cursor: pointer;

    transition: all 150ms ease-in-out;

    appearance: none;

    user-select: none;

    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    -webkit-touch-callout: none;

    &:focus:not([aria-disabled]) {
        box-shadow: ${0};
    }

    &[aria-disabled] {
        cursor: not-allowed;

        opacity: 0.5;
    }

    ${0};
`), ({
  size
}) => match(size).with('sm', () => '36px').with('md', () => '40px').exhaustive(), fonts.basic, ({
  $isWrapped
}) => $isWrapped ? 'normal' : 'nowrap', ({
  size
}) => match(size).with('sm', () => fontStack.textSm).with('md', () => fontStack.textMd).exhaustive(), shadows.focused, variantMixin);